import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';



@Component({
  name: 'NovoVTPopup',
  components: {
    TkForm,
  },
})
class NovoVTPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly loading: boolean;

  @Prop({ default: undefined })
  private readonly overrideSaveAction: (internalRow: any) => any;

  @Prop({ default: false })
  private readonly row: any;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly defaultRow: any = {
    IDGERALIQUIDO: 'S',
  };

  private internalValue = false;

  private internalLoading = {
    linhas: false,
    tiposLinha: false,
    numerosIntegracao: false,
    sentidos: false,
  };

  private internalRow: any = {};

  private fieldsData = {
    linhas: [],
    tiposLinha: [],
    numerosIntegracao: [],
    sentidos: [],
  };
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.internalLoading);
    const internalLoading = Util.oneTrue(...loadingValues);

    const loading = internalLoading || this.loading;

    return loading;
  }

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        // define-se na row como NRLINHATARIFA ao invés de NRLINHATRANSP
        // devido a problemas de modelagem
        name: 'NRLINHATARIFA',
        label: 'Linha',
        type: 'autocomplete',
        size: 4,
        required: true,
        descriptionField: 'DSLINHATRANSP',
        valueField: 'NRLINHATRANSP',
        items: this.fieldsData.linhas,
        outData: {
          DSLINHATRANSP: 'DSLINHATRANSP',
          CDINTEGRACAO: 'CDINTEGRACAO',
          VRTARIFA: 'VRTARIFA',
        },
        onInput: this.fixValorTarifa,
      },
      {
        name: 'VRTARIFA',
        label: 'Valor da Tarifa',
        type: 'text',
        size: 4,
        readonly: true,
      },
      {
        name: 'CDINTEGRACAO',
        label: 'Integração',
        type: 'text',
        size: 4,
        readonly: true,
      },
      {
        name: 'NRTIPOLINHAVINC',
        label: 'Tipo de Linha',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'DSTIPOLINHAVINC',
        valueField: 'NRTIPOLINHAVINC',
        items: this.fieldsData.tiposLinha,
        outData: {
          NRTIPOLINHAVINC: 'NRTIPOLINHAVINC',
          DSTIPOLINHAVINC: 'DSTIPOLINHAVINC',
        },
      },
      {
        name: 'IDGERALIQUIDO',
        label: 'Gera Líquido',
        type: 'select',
        size: 3,
        readonly: true,
        descriptionField: 'DSIDGERALIQUIDO',
        valueField: 'IDGERALIQUIDO',
        items: [
          {
            IDGERALIQUIDO: 'S',
            DSIDGERALIQUIDO: 'Sim',
          },
          {
            IDGERALIQUIDO: 'N',
            DSIDGERALIQUIDO: 'Não',
          },
        ],
      },
      {
        name: 'IDINTEGRESERVA',
        label: 'Reserva',
        type: 'select',
        size: 3,
        readonly: true,
        descriptionField: 'DSIDINTEGRESERVA',
        valueField: 'IDINTEGRESERVA',
        items: [
          {
            IDINTEGRESERVA: 'S',
            DSIDINTEGRESERVA: 'Sim',
          },
          {
            IDINTEGRESERVA: 'N',
            DSIDINTEGRESERVA: 'Não',
          },
        ],
      },
      {
        name: 'NRINTEGTRANSPM',
        label: 'Número de Integração',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'CDINTEGTRANSP',
        valueField: 'NRINTEGTRANSPM',
        items: this.fieldsData.numerosIntegracao,
        outData: {
          NRINTEGTRANSPM: 'NRINTEGTRANSPM',
          CDINTEGTRANSP: 'CDINTEGTRANSP',
          VRSALDOULTCONSULTA: 'VRSALDOULTCONSULTA',
          IDINTEGRESERVA: 'IDINTEGRESERVA',
        },
      },
      {
        name: 'NRSENTIDOLINHA',
        label: 'Sentido da Linha',
        type: 'autocomplete',
        size: 6,
        required: true,
        descriptionField: 'DSSENTIDOLINHA',
        valueField: 'NRSENTIDOLINHA',
        items: this.fieldsData.sentidos,
      },
      {
        name: 'QTLINHATARIFA',
        label: 'Quantidade',
        type: 'number',
        size: 4,
        required: true,
      },
      {
        name: 'DTINILINHAVINC',
        label: 'Início',
        type: 'date',
        size: 4,
        required: true,
      },
      {
        name: 'DTFIMLINHAVINC',
        label: 'Fim',
        type: 'date',
        size: 4,
      },
      {
        name: 'DSOBSLINHAVINC',
        label: 'Observação',
        type: 'textarea',
        size: 12,
        rows: 2,
      },
    ];

    return fields;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.loadFields();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      if (this.row === null) {
        this.setDefaultRow();
      } else {
        this.internalRow = Util.deepCopy(this.row);
      }
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private onSave() {
    if (!this.validate()) {
      return;
    }

    if (this.overrideSaveAction) {
      this.overrideSaveAction(this.internalRow);
    } else {
      this.save();
    }
  }

  private async save() {
    //
  }

  private loadFields() {
    this.loadLinhas();
    this.loadTiposLinha();
    this.loadNumerosIntegracao();
    this.loadSentidos();
  }

  private async loadLinhas() {
    this.internalLoading.linhas = true;

    try {
      this.fieldsData.linhas =
        await NovaSolicitacaoController.getLinhaTransporteAtiva(false);
    } finally {
      this.internalLoading.linhas = false;
    }
  }

  private async loadTiposLinha() {
    this.internalLoading.tiposLinha = true;

    try {
      this.fieldsData.tiposLinha =
        await NovaSolicitacaoController.getTipolinhavinc(false);
    } finally {
      this.internalLoading.tiposLinha = false;
    }
  }

  private async loadNumerosIntegracao() {
    this.internalLoading.numerosIntegracao = true;

    try {
      this.fieldsData.numerosIntegracao =
        await NovaSolicitacaoController.getIntegtransp(false);
    } finally {
      this.internalLoading.numerosIntegracao = false;
    }
  }

  private async loadSentidos() {
    this.internalLoading.sentidos = true;

    try {
      this.fieldsData.sentidos =
        await NovaSolicitacaoController.getSentidolinha(false);
    } finally {
      this.internalLoading.sentidos = false;
    }
  }

  private setDefaultRow() {
    this.internalRow = Util.deepCopy(this.defaultRow);
  }

  private validate(): boolean {
    if (!this.validateFields()) {
      return false;
    }

    if (!DateUtil.validateDates(this.internalRow.DTINILINHAVINC, this.internalRow.DTFIMLINHAVINC)) {
      return false;
    }

    if (!this.validateQuantidade()) {
      return false;
    }

    return true;
  }

  private fixValorTarifa() {
    const valorTarifa: string = this.internalRow.VRTARIFA;
    const nrLinha: string = this.internalRow.NRLINHATARIFA;

    if (!valorTarifa || !nrLinha) {
      this.internalRow.VRTARIFA = '';
      return;
    }

    let [reais, centavos] = valorTarifa.split('.');

    centavos = centavos || '';
    centavos = centavos.padEnd(2, '0');

    const valor = `R$${reais},${centavos}`;

    this.internalRow.VRTARIFA = valor;
  }

  private validateQuantidade(): boolean {
    const quantidade: number = this.internalRow.QTLINHATARIFA;

    if (quantidade <= 0) {
      const message = 'A quantidade deve ser maior que 0!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return false;
    }

    return true;
  }

  private validateFields(): boolean {
    const isValid: boolean = (this.$refs.form as any).validate(true);

    if (!isValid) {
      const message = 'Preencha todos os campos obrigatórios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return;
    }

    return isValid;
  }
  // #endregion
}

export default NovoVTPopup;
